import React, { useEffect, useRef, useState } from "react";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { Card, CardBody, Row, Col, Button } from "reactstrap";

import { NoDataIndication } from "./NoDataIndicator";

import {
  defaultSorted,
  getConfigColumns,
} from "../helpers";
import { DeliveryConfigModal } from "./DeliveryConfigModal";
import { useDispatch, useSelector } from "react-redux";
import { getDeliveryConfiguration, hideNotification, setDeliveryConfiguration, deleteDeliveryConfiguration } from "store/delivery-configuration/actions";
import { getConfigurationValidation } from "../helpers";
import { Notification } from "./Notification";

export const LocalDelivery = () => {
  // hooks, redux connection
  const dispatch = useDispatch();
  const { deliveryConfiguration } = useSelector(state => ({
    deliveryConfiguration: state.deliveryConfiguration.dataDeliveryConfiguration.deliveryConfiguration,
  }));
  const { success } = useSelector(state => ({
    success: state.deliveryConfiguration.dataDeliveryConfiguration.success,
  }));
  const { error } = useSelector(state => ({
    error: state.deliveryConfiguration.dataDeliveryConfiguration.error,
  }));
  // refs
  const timeOutRef = useRef(null);
  // state
  const [pickedConfigurationKey, setPickedConfigurationKey] = useState(undefined);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // effects
  useEffect(() => {
    if (deliveryConfiguration === undefined) {
      dispatch(getDeliveryConfiguration());
    }
  }, [dispatch, deliveryConfiguration]);

  useEffect(() => {
    if (success.open || error.open) {
      timeOutRef.current = setTimeout(() => {
        dispatch(hideNotification());
      }, 5000);
    }

    return () => clearTimeout(timeOutRef.current);
  }, [success, error]);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  // Form actions
  const setDeliveryKey = postCode => {
    dispatch(setDeliveryConfiguration(postCode));
    setIsModalOpen(false);
  };
  const updateDeliveryKey = postCode => {
    dispatch(setDeliveryConfiguration(postCode));
    setIsModalOpen(false);
  };
  const handleCloseModal = () => {
    setPickedConfigurationKey(undefined);
    setIsModalOpen(false);
  };
  // Table actions
  const deletePostCodeByKey = key => {
    dispatch(deleteDeliveryConfiguration({ key }));
    setPickedConfigurationKey(undefined);
  };
  const handleEditButton = configurationKey => {
    setPickedConfigurationKey(prev => configurationKey);
    setIsModalOpen(true);
  };
  // Table columns
  const validation = getConfigurationValidation(
    pickedConfigurationKey,
    setDeliveryKey,
    updateDeliveryKey
  );
  const postCodeColumns = getConfigColumns(
    handleEditButton,
    deletePostCodeByKey
  );

  return (
    <>
      <h2 className="font-size-18 mb-4 ">Ciężarówka buduj.pl</h2>
      <Card>
        <CardBody>
          <Notification success={success} error={error} />
          {deliveryConfiguration?.length > 0 ? (
            <ToolkitProvider
              keyField="id"
              data={deliveryConfiguration}
              columns={postCodeColumns}
              search
            >
              {props => {
                return (
                  <React.Fragment>
                    <Row>
                      <Col sm="4">
                        <div className="search-box me-2 mb-2 d-inline-block">
                          <div className="position-relative">
                            <Search.SearchBar
                              {...props.searchProps}
                              placeholder="Szukaj..."
                            />
                            <i className="bx bx-search-alt search-icon" />
                          </div>
                        </div>
                      </Col>
                      <Col sm="8">
                        <div className="text-sm-end">
                          <Button
                            color="primary"
                            className="font-16 btn-block btn btn-primary"
                            onClick={toggleModal}
                          >
                            <i className="mdi mdi-plus-circle-outline me-1" />
                            Dodaj klucz konfiguracyjny
                          </Button>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl="12">
                        <BootstrapTable
                          {...props.baseProps}
                          bordered={false}
                          defaultSorted={defaultSorted}
                          classes={"align-middle"}
                          headerWrapperClasses={"table-light"}
                          noDataIndication={() => <NoDataIndication />}
                        />
                      </Col>
                    </Row>
                  </React.Fragment>
                );
              }}
            </ToolkitProvider>) : (
            <Row>
              <Col sm="6">
                <span>Brak ustawień</span>
              </Col>
              <Col sm="6">
                <div className="text-sm-end">
                  <Button
                    color="primary"
                    className="font-16 btn-block btn btn-primary"
                    onClick={() => {
                      setPickedConfigurationKey(undefined);
                      toggleModal();
                    }}
                  >
                    <i className="mdi mdi-plus-circle-outline me-1" />
                    Dodaj zmienne konfiguracyjne
                  </Button>
                </div>
              </Col>
            </Row>
          )}
        </CardBody>
      </Card>
      <DeliveryConfigModal
        isOpen={isModalOpen}
        toggle={handleCloseModal}
        pickedConfigurationKey={pickedConfigurationKey}
        validation={validation}
      />
    </>
  );
};
